import FastMarquee from "react-fast-marquee";

const items = ["Auto Detailing", "Home Interiors", "Bozeman, MT", "Full Interior Detail", "Showroom Finish"];

export default function Marquee() {
  return (
    <section className="py-10 border-y border-border bg-secondary/40 overflow-hidden" data-testid="marquee-section">
      <FastMarquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-item text-4xl sm:text-5xl lg:text-6xl font-serif italic text-foreground/90 px-8">
              {t}
            </span>
            <span className="text-primary text-3xl">&bull;</span>
          </div>
        ))}
      </FastMarquee>
    </section>
  );
}
